import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_COPIED_TEMPLATE] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.copiedTemplate = payload
  },
  [types.SET_EMAILTEMPLATE] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.emailtemplate = payload
  },
  [types.SET_EMAILTEMPLATES] (state, payload) {
    state.emailtemplates = payload.data
    state.pagination = payload.meta.pagination
  }
}
